module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/pet-e7dc12a6db8e4594785c4d32ccbe8f37.webp";